import { Injectable } from "@angular/core";
import { FutureCycleFillRule } from "../rules/future-cycle-fill-rule";
import { IPendingTransactionDetails } from "src/app/shared/interfaces/pending-transaction-details.interface";
import { BusinessRuleViolation } from "src/app/shared/interfaces/business-rule.interface";

@Injectable()
export class ValidationService {
  private beforeConfirmingRules: FutureCycleFillRule[] = [
    new FutureCycleFillRule(),
    // TODO: add more rules with new requirements 
  ];

  validateBeforeConfirming(tx: IPendingTransactionDetails): BusinessRuleViolation[] {
    return this.beforeConfirmingRules
      .map(r => r.check(tx))
      .filter((v): v is BusinessRuleViolation => v != null);
  }
}